app.service("RangeInfoService", ['$rootScope', function ($rootScope) {

    const service = this;
    const modelConstructor = $rootScope.model_constructor;
    const RouteChoice = modelConstructor.RouteChoice;
    const siteHelper = $rootScope.site_helper;

    const RangeInfoModel = modelConstructor.extend(modelConstructor.RouteModel, {
        id: "range_info",
        name: "Range Info",
        navigation_pointer: "range_info_id",
        choice_is_breadcrumb: true,
        choice_order: ['kitchen_rigid_flat_pack', 'kitchen_inrail', 'bedroom_flat_pack',
            'valore', 'ora', 'jayline', 'wilton', 'bella', 'zurfiz', 'thornbury', 'hadley', 'lacarre', 'hettich', 'clicbox']
    });

    this.factory = new modelConstructor.RouteFactory({
        choices: {
            kitchen_rigid_flat_pack: new RouteChoice({
                name: "Rigid / Flat-Pack Kitchens",
                next_model_id: "info",
                state_ids: {
                    solution_id: "kitchen_rigid_flat_pack"
                }
            }),
            kitchen_inrail: new RouteChoice({
                name: "InRail Rigid Kitchens",
                state_ids: {
                    solution_id: "kitchen_inrail",
                    assembly_id: "rigid"
                }
            }),
            bedroom_flat_pack: new RouteChoice({
                name: "Flat-Pack Bedrooms",
                state_ids: {
                    solution_id: "bedroom_flat_pack",
                    assembly_id: "flat_pack"
                }
            }),
            valore: new RouteChoice({
                name: "Valore",
                state_ids: {
                    request_range_id: "valore",
                    site_range_id: "valore"
                }
            }),
            ora: new RouteChoice({
                name: "Ora",
                state_ids: {
                    request_range_id: "pronto",
                    site_range_id: "ora"
                }
            }),
            jayline: new RouteChoice({
                name: "Jayline",
                state_ids: {
                    request_range_id: "pronto",
                    site_range_id: "jayline"
                }
            }),
            wilton: new RouteChoice({
                name: "Wilton",
                state_ids: {
                    request_range_id: "pronto",
                    site_range_id: "wilton"
                }
            }),
            bella: new RouteChoice({
                name: "Bella",
                state_ids: {
                    request_range_id: "bella",
                    site_range_id: "bella"
                }
            }),
            zurfiz: new RouteChoice({
                name: "Zurfiz",
                state_ids: {
                    request_range_id: "zurfiz",
                    site_range_id: "zurfiz"
                }
            }),
            thornbury: new RouteChoice({
                name: "Thornbury",
                state_ids: {
                    request_range_id: "pronto",
                    site_range_id: "thornbury"
                }
            }),
            hadley: new RouteChoice({
                name: "Hadley",
                state_ids: {
                    request_range_id: "pronto",
                    site_range_id: "hadley"
                }
            }),
            lacarre: new RouteChoice({
                name: "Lacarre",
                site_range_id: "lacarre",
                state_ids: {
                    request_range_id: "pronto",
                    site_range_id: "lacarre"
                }
            }),
            hettich: new RouteChoice({
                name: "Hinges and Drawers",
                public_id: "hinges_and_drawers",
                site_range_id: "hettich"
            }),
            clicbox: new RouteChoice({
                name: "Cabinets",
                public_id: "cabinets",
                site_range_id: "clicbox"
            })
        },
        birth: function (values) {
            return new RangeInfoModel(values);
        },

        applyModelVariation: applyModelVariation
    });

    function applyModelVariation(model) {

        this.super(model);

        const choiceOrder = model.choice_order;

        const choices = siteHelper.cloneChoices(
            service.factory.choices
            , choiceOrder);


        for (let choiceID in choices) {
            const choice = choices[choiceID];
            choice.state_values.rangeInfoName = choice.name;
        }
        model.choice_order = choiceOrder;
        model.choices = choices;
    }

    this.getAssignedChoice = function (choiceID) {

        const rangeInfoModel = $rootScope.navigation_manager.createNavigationModel(null, {
            browse_id: "range_info",
            range_info_id: choiceID
        }).state_models.range_info;
        const rangeInfoChoice = rangeInfoModel ? rangeInfoModel.choices[choiceID] : null;
        return rangeInfoChoice ? rangeInfoChoice : null;
    }

}]);